<template>
  <v-dialog v-bind="computedProps" v-on="computedListeners" v-model="showDialog">
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer/>
        <v-toolbar-title>配車車両編集画面 ＜配車表 : {{haishahyoCdNm}}＞</v-toolbar-title>
        <v-spacer/>
        <v-btn @click="onCloseClick" text>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container fluid class="px-5 ma-0">
          <v-row no-gutters>
            <v-col :cols="3" class="px-1">
              <span class="search-number">{{ filteredRows.length }}</span>件 の車両が紐づけされています。
            </v-col>
            <v-col :cols="3" />
            <v-col :cols="3" class="mt-2">
              <span class="text-right-black-bold">さらにフリーワードで絞り込む</span>
            </v-col>
            <v-col :cols="3" class="px-1">
              <dd-narrow-down-text-box label="" adjustStyle="padding-top:0px" v-model="searchText"/>
            </v-col>
          </v-row>

          <hr class="section-line mb-2">

          <v-row no-gutters>
            <v-col :cols="6">
              <dd-custom-button @click="onSharyoHimofukeNewButtonClick">
                新たに車両を追加する
              </dd-custom-button>
            </v-col>
            <v-col :cols="6" class="px-1">
              <dd-select-items-per-page
                ref="pagination1"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="filteredRows"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-2">
            <v-col :cols="12">
              <v-data-table
                item-key="sharyoNo"
                :headers="headers"
                :items="filteredRows"
                :search="searchText"
                :loading="loading"
                loading-text="検索中のため、少々お待ちください。"
                v-model="selectedItem"
                showSelect
                :items-per-page="itemsPerPage"
                :page.sync="page"
                :custom-filter="filtering"
                no-data-text="対象データはありません"
                calculate-widths
                fixed-header
                hide-default-footer
                locale="ja-jp"
                dense
              >
                <template v-slot:[`item.hyojiOrder`]="p">
                  <dd-edit-dialog
                    :value.sync="p.item.hyojiOrder"
                    :valueType="Ctrls.InputTypes.Numerical"
                    :numIntegerDigit=4
                    :numMinorDigit=0
                    :numMax=9999
                    :numMin=1
                    @save="p.item.hyojiOrder = $event"
                    @close="onEditCloseNum($event, p)"
                    />
                </template>

                <template v-slot:[`item.saveAction`]="{item}">
                  <template v-if="item.editFlg == true">
                    <dd-icon-button-with-tooltip
                      message="行の変更を反映します"
                      icon="mdi-content-save-edit"
                      @click="onSave(item)"/>
                    <dd-icon-button-with-tooltip
                      message="行の変更を元に戻します"
                      icon="mdi-cancel"
                      @click="onCancel(item)"/>
                  </template>
                  <template v-else>
                    <dd-icon-button-with-tooltip
                      message="変更がない場合は使用できません"
                      color="gray"
                      icon="mdi-content-save-edit"/>
                  </template>
                </template>
                <template v-if="modeKengen == 2" v-slot:[`item.deleteAction`]="{item}">
                  <dd-icon-button-with-tooltip
                    message="行を削除します"
                    icon="mdi-delete"
                    @click="onDelete(item)"/>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-row no-gutters class="px-1 py-0 mt-3" v-if="filteredRows.length > 0">
          <v-col :cols="3">
            <dd-transparent-button :minWidth="120" @click="onCloseClick">
              <v-icon color="#1F2B38">mdi-close-circle</v-icon>ヘルプを閉じる
            </dd-transparent-button>
          </v-col>
          <v-col :cols="3">
            <dd-custom-button
              v-if="modeKengen === 2"
              :disabled="isHimodukeButtonDisabled"
              @click="onHaishahyoSharyoRelationDeleteClick">
              チェックした車両の紐付けを解除する
            </dd-custom-button>
          </v-col>
          <v-col :cols="6">
            <v-row no-gutters justify="end">
              <dd-select-items-per-page
                ref="pagination2"
                :itemsPerPage.sync="itemsPerPage"
                :currentPage.sync="page"
                :items="filteredRows"
                @changeItemsPerPage="changeItemsPerPage"
                @changePage="changePage"
              />
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

    <!-- 配車車両追加ダイアログ -->
    <dd-sharyo-himoduke-dialog
      :showDialog="showSharyoHimodukeDialog"
      :haishahyoCdNm="haishahyoCdNm"
      ref="sharyoHimodukeDialog"
      @saveClose="onSharyoHimodukeDialogSaveClosed"
      @close="onSharyoHimodukeDialogClosed"
    />

  </v-dialog>
</template>
<script>
import DdCustomButton from '@/components/DdCustomButton'
import DdEditDialog from '@/components/DdEditDialog'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdSelectItemsPerPage from '@/components/DdSelectItemsPerPage'
import DdSharyoHimodukeDialog from '@/components/DdSharyoHimodukeDialog'

import { mapGetters } from 'vuex'

import flowMixin from '@/mixins/flowMixins'
import controls from '@/rahmen/controls'
import dolly from '@/rahmen/utils/dolly'
import modals from '@/ddv2.library/modals'
import formatter from '@/ddv2.library/utils/formatter'

// import filter from '@/rahmen/utils/filters'

export default {
  name: 'DdHaishahyoHimodukeDialog',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdEditDialog,
    DdTransparentButton,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdSelectItemsPerPage,
    DdSharyoHimodukeDialog
  },
  props: {
    /**
     * 表示状態
     */
    showDialog: Boolean,
    /**
     * ダイアログタイトル
     */
    titleText: String
  },
  data: () => ({
    rec: [],
    searchText: '',
    haishahyoCd: '',
    haishahyoCdNm: '',
    ctypes: controls,
    modeKengen: 2,
    showSharyoHimodukeDialog: false,
    // ページネーション用
    itemsPerPage: 0,
    page: 1,
    /**
     * 一覧内容
     */
    loading: false,
    selectedItem: [],
    rows: []
    /*
     *
     */
  }),
  created () {
  },
  mounted () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
    }),
    computedProps () {
      return {
        ...this.$props,
        persistent: true,
        noClickAnimation: true,
        scrollable: true,
        maxWidth: '85%'
      }
    },
    filteredRows () {
      return this.rows
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    isHimodukeButtonDisabled () {
      return this.selectedItem.length === 0
    }
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        searchText: this.searchText
      }
    },
    fetchData: function (selectedRow) {
      return new Promise((resolve) => {
        this.HttpClient
          .get('api/v1/VwCMstHaishahyoSharyo/GetAll')
          .then((data) => {
            var dataList = data.payload
            dataList = dataList.filter((elem) => {
              return elem.haishahyoCd === selectedRow.haishahyoCd
            }).map((elem) => {
              elem.editFlg = false
              return elem
            }).sort(function (a, b) {
              if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
              if (a.sharyoNo > b.sharyoNo) { return 1 }
              if (a.sharyoNo === b.sharyoNo) { return 0 }
              return -1
            })
            this.rows = dataList
            this.haishahyoCd = selectedRow.haishahyoCd
            this.haishahyoCdNm = selectedRow.haishahyoCd + ' : ' + selectedRow.haishahyoNm
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
            resolve()
          })
      })
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: [],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('ThKamotsuHimodukeNippoSearchDialog.defineHeaderPromise')
            self.headers = [
              { text: 'ID', value: 'id', align: ' d-none' },
              { text: '車両番号', value: 'sharyoNo' },
              { text: '所有区分', value: 'hacchusakiFlgNm' },
              { text: '営業所', value: 'eigyoshoNm' },
              { text: '発注先', value: 'hacchusakiNm' },
              { text: '自動車表示名', value: 'jidoshaHyojiNm' },
              { text: '自動車登録番号', value: 'torokuNo' },
              { text: '車種種別', value: 'shashuSbtNm' },
              { text: '表示順', value: 'hyojiOrder' },
              { text: '反映', value: 'saveAction', align: 'center', sortable: false, width: '5vw' },
              { text: '変更状況', value: 'memo', align: 'center', width: '5vw' },
              { text: '操作', value: 'deleteAction', align: 'center', sortable: false, width: '20px' }]
            resolve()
          })
        },
        initializeInputPromise: (c) => {
          return new Promise((resolve) => {
            self.rec = []
            self.rows = []
            self.selectedItem = []
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('savedInputRestorePromise')
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('ThKamotsuHimodukeNippoSearchDialog.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.researchPromise', c)
          return new Promise(resolve => {
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.restoreViewPromise', c)
          return new Promise(resolve => {
            this.searchText = c.cache.value.searchText || ''
            this.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('ThKamotsuHimodukeNippoSearchDialog.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        },
        settingLoadEffect: function () {
          return true
        }
      }
      this.initializeForViewer(opt)
    },
    onCloseClick: function (e) {
      /**
       * 無選択クローズ処理
       * @event click
       * @type {Event}
       */
      console.log('close clicked', this.showDialog)
      this.$emit('close', undefined)
      console.log('emited', this.showDialog)
      this.searchText = ''
      this.rec = []
      this.rows = []
      this.selectedItem = []
      // this.clear(false)
    },
    onSharyoHimofukeNewButtonClick: function () {
      this.$refs.sharyoHimodukeDialog.fetchData(this.haishahyoCd).then(() => {
        this.showSharyoHimodukeDialog = true
      })
    },
    onSharyoHimodukeDialogSaveClosed: function (itemList) {
      this.rows = itemList
      this.rows.sort(function (a, b) {
        if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
        if (a.sharyoNo > b.sharyoNo) { return 1 }
        if (a.sharyoNo === b.sharyoNo) { return 0 }
        return -1
      })
      this.cloneRows = dolly.clone(this.getCloneTargetMethod())
      this.showSharyoHimodukeDialog = false
      this.Effects.loadComplete()
    },
    onSharyoHimodukeDialogClosed: function () {
      this.showSharyoHimodukeDialog = false
    },
    isChanged: function (a, b) {
      if (a.hyojiOrder !== b.hyojiOrder) {
        return true
      } else {
        return false
      }
    },
    onEditCloseNum: function (e, row) {
      // /* eslint no-debugger: "warn" */
      // debugger
      if (e === true && isFinite(this.getNullValue(row.value))) {
        const index = this.rows.indexOf(row.item)
        this.rec = Object.assign({}, row.item)

        // 変更フラグ判定（≠Clone値は変更有とみなす）
        if (this.isChanged(this.rec, this.cloneRows.rows[index])) {
          this.rec.editFlg = true
        } else {
          this.rec.editFlg = false
        }

        Object.assign(this.rows[index], this.rec)
        // 画面への再描写 ※強制発火用にspliceを実行
        this.rows.splice()
      }
    },
    // Nullをゼロに変換(カンマ除去も)
    getNullValue (inputValue) {
      if (inputValue === null) { return 0 }
      if (inputValue === undefined) { return 0 }
      if (inputValue === '') { return 0 }
      return formatter.removeComma(inputValue)
    },
    setRowColorClass: function (item) {
      return item.editFlg === true ? 'cellBackgroundColorGreen' : ''
    },
    onCancel: function (item) {
      // サマリメッセージ初期化
      this.clearSummaryMessage()

      const index = this.rows.indexOf(item)
      this.getData(item.id, index)
    },
    /**
     * 更新後の再取得 ※対象行のデータとClone情報を差し替える
     * @param {} recId
     * @param {*} rowIndex
     * @returns
     */
    getData: function (recId, rowIndex) {
      // サマリメッセージ初期化
      // this.clearSummaryMessage()

      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/VwCMstHaishahyoSharyo/find?id=${recId}`)
          .then((data) => {
            this.rec = data.payload
            // 取得データを差し替え
            this.rec.editFlg = false
            this.rec.memo = ''

            Object.assign(this.rows[rowIndex], this.rec)
            this.rows.sort(function (a, b) {
              if (a.hyojiOrder - b.hyojiOrder !== 0) { return a.hyojiOrder - b.hyojiOrder }
              if (a.sharyoNo > b.sharyoNo) { return 1 }
              if (a.sharyoNo === b.sharyoNo) { return 0 }
              return -1
            })
            // CloneData更新
            this.cloneRows = dolly.clone(this.getCloneTargetMethod())
            // 画面への再描写 ※強制発火用にspliceを実行
            this.rows.splice()
          })
      })
    },
    onSave: function (item) {
      var m = 'COMQ0002'
      const p = modals.showConfirm
      p(m).then((ok) => {
        if (ok === false || ok === undefined) { return }

        const index = this.rows.indexOf(item)
        this.rec = Object.assign({}, item)
        if (!this.rec.hyojiOrder) {
          this.rec.hyojiOrder = 0
        }

        const self = this
        const opt = {
          registerRequestPromise: self.registerPromise,
          registerResponsePromise: (data) => {
            return new Promise(resolve => {
              // 更新後に自レコードのみ再取得
              this.getData(this.rec.id, index)
              self.Effects.loadComplete()
            })
          },
          getIdMethod: () => {
            return 0
          },
          continuousInputInitializePromise: (id) => {
            return new Promise(resolve => {
              resolve()
            })
          },
          getTransitionBackParams: function () {
            return {
              actionId: 0
            }
          },
          isUpdateModeMethod: function () {
            return true
          },
          isNoRefreshModeMethod: function () {
            return true
          },
          isNoMessageModeMethod: function () {
            return false
          },
          getSavedInputMethod: function () {
            return true
          }
        }
        this.register(opt)
      })
    },
    registerPromise: function () {
      // 更新処理実行
      // 自レコードのみを更新する
      var rtn = this.HttpClient.post('/api/v1/VwCMstHaishahyoSharyo/UpdateHyojiOrder', this.rec)
      return rtn
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },
    onDelete: function (item) {
      this.selectedItem = [item]
      this.onHaishahyoSharyoRelationDeleteClick()
    },
    onHaishahyoSharyoRelationDeleteClick: function () {
      const self = this
      self.rec = self.selectedItem
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/D2mstd0380/DeleteHaishahyoSharyoRelation', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {}
        },
        settingReloadWindow: function () {
          return true
        },
        isInvokeCallbackOnSuccess: function () {
          return true
        },
        onSuccessCallback: function () {
          return new Promise(resolve => {
            console.log(self.rec)
            self.rec.forEach(elem => {
              const index = self.rows.indexOf(elem)
              self.rows.splice(index, 1)
            })
            self.rec = []
            self.selectedItem = []
            resolve()
          })
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    // ページ操作
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    // ダミー
    onDummyFunction: function () {
      this.$emit('dummy')
    }
  }
}
</script>
<style scoped>
div.v-dialog__content.v-dialog__content--active {
   z-index: 400 !important;
}
</style>
